import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { PROPERTIES } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { getPropertiesMap } from 'src/common/services/properties/PropertiesService';

export const usePropertiesMapQuery = (enabled: boolean): UseQueryResult<Map<string, string>> =>
	useQuery([PROPERTIES], getPropertiesMap, {
		enabled
	});
